export const GET_PREDEFINED_SCRIPTS_REQ = 'GET_PREDEFINED_SCRIPTS_REQ';
export const GET_PREDEFINED_SCRIPTS_OK = 'GET_PREDEFINED_SCRIPTS_OK';